import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17]">
        <div className="flex items-center gap-3 text-slate-400">
          <span className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse-dot" />
          <span className="font-mono-niq text-xs tracking-widest uppercase">Verifying session</span>
        </div>
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children;
}
